module.exports = __webpack_public_path__ + "img/35.3ce7ddff.jpg";